import type { CityDto } from '@posilka/shared';

export const cityName = (c: Pick<CityDto, 'nameUz' | 'nameRu'>, lang: string) =>
  lang === 'ru' ? c.nameRu : c.nameUz;
